import { render } from "./CreateEditUserGroupDialog.vue?vue&type=template&id=29b298f3"
import script from "./CreateEditUserGroupDialog.vue?vue&type=script&lang=js"
export * from "./CreateEditUserGroupDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__